<template>
  <v-dialog max-width="600px" v-model="showDialogSelectPersonalMsisdnLocal" @update:model-value="dialogSelectPersonalMsisdnClose"
            @keydown.esc="handleEscape">
    <v-card>
      <v-card-title>
        <h4 class="highlighted">Select Phone Number</h4>
      </v-card-title>
      <v-card-text>
        <!-- Search by MSISDN pattern -->
        <v-row>
          <v-col cols="12">
            <v-text-field
                v-model="msisdnLike"
                label="Search by number (e.g. 0787000)"
                placeholder="Enter digits to search..."
                clearable
                dense
                outlined
                hide-details
                @input="onMsisdnLikeChange"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- MSISDN Class Filter -->
        <v-row class="mt-2">
          <v-col cols="12">
            <v-card-subtitle class="font-weight-bold pa-0 mb-2">Filter by Class</v-card-subtitle>
            <v-radio-group
                v-model="selectedMsisdnClassId"
                row
                dense
                hide-details
            >
              <v-radio :value="null" label="All"></v-radio>
              <v-radio
                v-for="msisdnClass in msisdnsClasses"
                :key="msisdnClass.id"
                :value="msisdnClass.id"
                :label="msisdnClass.name"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row class="border1 mt-2">
          <v-col  cols="12">
            <v-autocomplete name="Select Client"
                            v-model="selectedMsisdnID"
                            v-model:search="msisdnSearchText"
                            :items="filteredAvailableMsisdnsList"
                            item-value="msisdn_id"
                            item-text="msisdn"
                            item-title="msisdn"
                            label="Select MSISDN"
                            outlined
                            dense
                            clearable
                            auto-select-first
                            :loading="loadingMsisdns"
                            :disabled="loadingMsisdns"
                            @update:model-value="onSelectedMsisdnChange"
                            @focus="msisdnSearchText = ''"
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- Billing Options (Buy/Rent) - shown after MSISDN selection -->
        <v-row v-if="selectedMsisdnID && currentMsisdnBillingOptions.length > 0" class="mt-3">
          <v-col cols="12">
            <v-card-subtitle class="font-weight-bold pa-0 mb-2">Select Option</v-card-subtitle>
            <v-radio-group
                v-model="selectedBillingType"
                dense
                hide-details
                @update:model-value="onBillingTypeChange"
            >
              <v-radio
                  v-if="hasBuyOption"
                  value="buy"
                  :label="'Buy (One-time fee: ' + buyOptionPrice + ' ' + buyOptionCurrency + ')'"
              ></v-radio>
              <v-radio
                  v-if="hasRentOption"
                  value="rent"
                  label="Rent"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- Rent Period Selection - shown only when rent is selected -->
        <v-row v-if="selectedBillingType === 'rent' && rentOptions.length > 0" class="mt-2">
          <v-col cols="12">
            <v-card-subtitle class="font-weight-bold pa-0 mb-2">Select Rental Period</v-card-subtitle>
            <v-select
                v-model="selectedBillingPeriodId"
                :items="rentOptions"
                item-value="billing_period_id"
                item-title="label"
                label="Rental Period"
                outlined
                dense
                @update:model-value="onBillingPeriodChange"
            ></v-select>
          </v-col>
        </v-row>

        <!-- Price Display -->
        <v-row v-if="selectedBillingType && displayPrice !== null" class="mt-2">
          <v-col cols="12">
            <v-alert type="info" density="compact">
              <strong>Total: {{ displayPrice }} {{ displayCurrency }}</strong>
              <span v-if="selectedBillingType === 'rent' && selectedBillingPeriodName">
                / {{ selectedBillingPeriodName }}
              </span>
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-if="selectedMsisdnID && currentMsisdnBillingOptions.length === 0" class="mt-2">
          <v-col cols="12">
            <v-alert type="warning" density="compact">
              No pricing available for this number
            </v-alert>
          </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>

        <v-row justify="space-around" class="mt-3 mb-3">
          <v-btn  @click="closeSelectPersonalMsisdn()" large color="danger">Cancel</v-btn>
          <v-btn large color="primary" @click="addNewServiceLocal" class="success " :loading="loading" :disabled="!canSubmit">Select this number</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import {getAvailableMsisdnsList} from "@/composables/useGetAvailableMsisdnsAPI";

export default defineComponent({
  name: 'SelectAvailableMsisdn',
  components: {},
  props: {
    currentSimIndex: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      showToken: false,
      token: '',
      showDialogSelectPersonalMsisdnLocal: true,
      selectedMsisdnID: null,
      msisdnSearchText: '',
      msisdnLike: "",
      showMsisdnsLikeList: true,
      loading: false,
      showMsisdnPackageDetails: false,
      msisdnPackageDetails: null,
      selectedMsisdnClassId: null,
      msisdnsClasses: [],
      availableMsisdnsList: [],
      loadingMsisdns: false,
      searchTimeout: null,
      // New billing options
      selectedBillingType: null,       // 'buy' or 'rent'
      selectedBillingPeriodId: null,   // for rent
      currentMsisdnBillingOptions: [], // billing options for selected MSISDN
      billingPeriods: [],              // all billing periods from API
      inputRules: [
        v => !!v || 'This field is required',
      ],
    }
  },
  methods: {
    dialogSelectPersonalMsisdnClose(value) {
      // Emitted when dialog visibility changes
      log("am primit eveniment ca v-dialog s.a inchis")
      if (!value) {
        // alert("am primit eveniment ca v-dialog s.a inchis si no value")
        this.$emit('dialogSelectPersonalMsisdnClosedEvent',[this.selectedMsisdnID]);
      }
    },
    handleEscape() {
      // alert("am primit eveniment ca v-dialog a apasat escape")
      // Emitted specifically when Escape is pressed
      this.$emit('dialogSelectAvailableMsisdnEscapedEvent');
    },
    closeSelectPersonalMsisdn() {
      log("am chemat method closeSelectPersonalMsisdn")
      // Emitted specifically when Escape is pressed
      this.$emit('dialogSelectAvailableMsisdnEscapedEvent',[this.selectedMsisdnID]);
    },
    addNewServiceLocal() {
      if (!this.selectedMsisdnID) {
        alert("Selectează un număr de telefon")
        return
      }
      if (!this.selectedBillingType) {
        alert("Selectează tipul de achiziție (Buy sau Rent)")
        return
      }
      if (this.selectedBillingType === 'rent' && !this.selectedBillingPeriodId) {
        alert("Selectează perioada de închiriere")
        return
      }

      // Find selected MSISDN details
      const selectedMsisdn = this.availableMsisdnsList.find(m => m.msisdn_id === this.selectedMsisdnID)

      // Emit to parent with simIndex, msisdn data and billing info
      this.$emit('msisdnSelected', {
        simIndex: this.currentSimIndex,
        msisdn_id: this.selectedMsisdnID,
        msisdn: selectedMsisdn?.msisdn || null,
        billing_type: this.selectedBillingType,
        billing_period_id: this.selectedBillingType === 'rent' ? this.selectedBillingPeriodId : null,
        billing_period_name: this.selectedBillingPeriodName,
        price: this.displayPrice,
        currency: this.displayCurrency
      });

      // Close dialog
      this.showDialogSelectPersonalMsisdnLocal = false
    },
    onSelectedMsisdnChange(msisdnId) {
      log("Am selectat msisdn_id: " + msisdnId)
      // Reset billing selections
      this.selectedBillingType = null
      this.selectedBillingPeriodId = null

      if (msisdnId) {
        // Find billing options for selected MSISDN
        const selectedMsisdn = this.availableMsisdnsList.find(m => m.msisdn_id === msisdnId)
        log("Selected MSISDN object:")
        log(JSON.stringify(selectedMsisdn))
        this.currentMsisdnBillingOptions = selectedMsisdn?.billing_options || []
        log("Billing options count: " + this.currentMsisdnBillingOptions.length)
        log("Billing options:")
        log(JSON.stringify(this.currentMsisdnBillingOptions))

        // Auto-select if only one option type available
        if (this.hasBuyOption && !this.hasRentOption) {
          this.selectedBillingType = 'buy'
        } else if (this.hasRentOption && !this.hasBuyOption) {
          this.selectedBillingType = 'rent'
          // Auto-select first rent period if only one
          if (this.rentOptions.length === 1) {
            this.selectedBillingPeriodId = this.rentOptions[0].billing_period_id
          }
        }
      } else {
        this.currentMsisdnBillingOptions = []
      }
      this.showMsisdnPackageDetails = true
    },
    onBillingTypeChange(type) {
      log("Billing type changed to: " + type)
      // Reset billing period when switching to buy
      if (type === 'buy') {
        this.selectedBillingPeriodId = null
      } else if (type === 'rent' && this.rentOptions.length === 1) {
        // Auto-select first rent period if only one
        this.selectedBillingPeriodId = this.rentOptions[0].billing_period_id
      }
    },
    onBillingPeriodChange(periodId) {
      log("Billing period changed to: " + periodId)
    },
    onMsisdnLikeChange() {
      // Debounce - wait 500ms after user stops typing
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.loadAvailableMsisdns()
      }, 500)
    },
    async loadAvailableMsisdns() {
      log("Loading available MSISDNs with msisdn_like: " + this.msisdnLike)
      this.loadingMsisdns = true
      try {
        const options = {
          limit: 100
        }
        if (this.msisdnLike && this.msisdnLike.length >= 3) {
          options.msisdn_like = this.msisdnLike
        }
        const response = await getAvailableMsisdnsList(this.token, options)
        log("Response from getAvailableMsisdnsList:")
        log(response)
        if (response.error === false) {
          this.availableMsisdnsList = response.msisdns_list || []
          this.msisdnsClasses = response.msisdn_classes || []
          this.billingPeriods = response.billing_periods || []
          log("Loaded " + this.availableMsisdnsList.length + " MSISDNs")
        } else {
          log("Error loading MSISDNs: " + response.message)
        }
      } catch (err) {
        log("Exception loading MSISDNs:")
        log(err)
      } finally {
        this.loadingMsisdns = false
      }
    },
    async loadFirstAvailableMsisdns() {
      log("Loading available MSISDNs with msisdn_like: " + this.msisdnLike)
      this.loadingMsisdns = true
      try {
        const options = {
          limit: 100
        }
        if (this.msisdnLike && this.msisdnLike.length >= 3) {
          options.msisdn_class_id = 1
        }
        const response = await getAvailableMsisdnsList(this.token, options)
        log("Response from getAvailableMsisdnsList:")
        log(response)
        if (response.error === false) {
          this.availableMsisdnsList = response.msisdns_list || []
          this.msisdnsClasses = response.msisdn_classes || []
          log("Loaded " + this.availableMsisdnsList.length + " MSISDNs")
        } else {
          log("Error loading MSISDNs: " + response.message)
        }
      } catch (err) {
        log("Exception loading MSISDNs:")
        log(err)
      } finally {
        this.loadingMsisdns = false
      }
    }
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    getLoggedIn().then(()=>{
      log ("dupa created in SelectAvailableMsisdn avem:")
      log("autorizare in  SelectAvailableMsisdn after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      this.client_id=user.value.client_id
      this.token = token.value
      this.showDialogSelectPersonalMsisdnLocal=true
      // Load available MSISDNs from API
      this.loadAvailableMsisdns()
    })
  },
  watch: {
    selectedMsisdnID(newVal, oldVal) {
      console.log("=== WATCH: selectedMsisdnID changed from", oldVal, "to", newVal)
    }
  },
  computed: {
    filteredAvailableMsisdnsList() {
      console.log("=== filteredAvailableMsisdnsList computed, items:", this.availableMsisdnsList.length)
      if (this.availableMsisdnsList.length > 0) {
        console.log("First item billing_options:", this.availableMsisdnsList[0].billing_options)
      }
      if (this.selectedMsisdnClassId === null) {
        log("Filter: showing all MSISDNs")
        return this.availableMsisdnsList
      } else {
        log("Filter: showing MSISDNs with class_id = " + this.selectedMsisdnClassId)
        return this.availableMsisdnsList.filter((msisdn) => {
          return msisdn.msisdn_class_id === this.selectedMsisdnClassId
        })
      }
    },
    // Check if buy option is available
    hasBuyOption() {
      return this.currentMsisdnBillingOptions.some(opt => opt.type === 'buy')
    },
    // Check if rent option is available
    hasRentOption() {
      return this.currentMsisdnBillingOptions.some(opt => opt.type === 'rent')
    },
    // Get buy option details
    buyOption() {
      return this.currentMsisdnBillingOptions.find(opt => opt.type === 'buy')
    },
    buyOptionPrice() {
      return this.buyOption?.price || 0
    },
    buyOptionCurrency() {
      return this.buyOption?.currency || 'EUR'
    },
    // Get all rent options with labels for dropdown
    rentOptions() {
      return this.currentMsisdnBillingOptions
          .filter(opt => opt.type === 'rent')
          .map(opt => ({
            ...opt,
            label: `${opt.billing_period_name || 'Period'} - ${opt.price} ${opt.currency}`
          }))
    },
    // Get selected rent option
    selectedRentOption() {
      if (!this.selectedBillingPeriodId) return null
      return this.rentOptions.find(opt => opt.billing_period_id === this.selectedBillingPeriodId)
    },
    // Display price based on selection
    displayPrice() {
      if (this.selectedBillingType === 'buy') {
        return this.buyOptionPrice
      } else if (this.selectedBillingType === 'rent' && this.selectedRentOption) {
        return this.selectedRentOption.price
      }
      return null
    },
    // Display currency based on selection
    displayCurrency() {
      if (this.selectedBillingType === 'buy') {
        return this.buyOptionCurrency
      } else if (this.selectedBillingType === 'rent' && this.selectedRentOption) {
        return this.selectedRentOption.currency
      }
      return 'EUR'
    },
    // Get selected billing period name
    selectedBillingPeriodName() {
      return this.selectedRentOption?.billing_period_name || null
    },
    // Check if form is valid for submission
    canSubmit() {
      if (!this.selectedMsisdnID) return false
      if (!this.selectedBillingType) return false
      if (this.selectedBillingType === 'rent' && !this.selectedBillingPeriodId) return false
      return true
    }
  }
})
</script>
